<template>
  <div class="seed-record">
      <div v-if="recordList.length == 0" class="no-record">暂无记录</div>
      <div v-else class="record" v-for="(item, index) in recordList" :key="index">
          <div class="left">
              <p class="name">{{item.description}}</p>
              <p class="date">{{item.date}}</p>
          </div>
          <div class="right">
              <span class="recharge" v-show="item.type == 1">+</span>
              <span class="spend" v-show="item.type == 0">-</span>
              {{item.amount}}
          </div>
      </div>
  </div>
</template>
<script>
import { Uploader, Toast, Loading } from "vant";
import {getSeedRecord} from '@/api/api';
export default {
  components: {
    [Uploader.name]: Uploader,
    [Loading.name]: Loading
  },
  data() {
    return {
        recordList: []
    };
  },
  beforeMount: function() {
    this.init();
  },
  methods: {
    init() {
        let that = this
        getSeedRecord().then(res => {
            that.recordList = res.data.recordList
            if(that.recordList.length){
                that.recordList.map(function(item, index){
                  let date = new Date(item.time)
                  let y = date.getFullYear()
                  let m = date.getMonth() + 1
                  let d = date.getDate()
                  let h = date.getHours()
                  let mi = date.getMinutes()
                  item.date = y + '-' + (m >= 10 ? m : ('0' + m)) + '-' + (d >= 10 ? d : ('0' + d))
                    + ' ' + (h >= 10 ? h : ('0' + h)) + ':' + (mi >= 10 ? mi : ('0' + mi))
                    return item
                })
            }
        })
    },
  }
};
</script>
<style lang="less">
.seed-record {
    padding: 7px 20px 0 20px;
    .no-record{
        text-align: center;
        padding-top: 40%;
        font-size: 16px;
        color: #999;
    }
    .record{
        padding-bottom: 15px;
        position: relative;
        .left{
            .name{
                font-size:16px;
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                color:rgba(24,22,42,1);
                line-height:22px;
            }
            .date{
                font-size:12px;
                color:rgba(140,139,151,1);
                line-height:16px;
                margin-top: 3px;
            }
        }
        .right{
            font-size:14px;
            font-family:PingFangSC-Medium,PingFang SC;
            font-weight:500;
            color:rgba(52,167,149,1);
            line-height:20px;
            position: absolute;
            right: 0px;
            top: 12px;
            .spend{
                color: #18162A;
            }
        }
    }
}
input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #ccc;
}
input:-moz-placeholder,
textarea:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #ccc;
}
input::-moz-placeholder,
textarea::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #ccc;
}
input:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #ccc;
}
// Toast loading
.van-loading-custom {
  background-color: rgba(50, 50, 51, 0);
  .van-loading {
    width: 50px;
    height: 50px;
  }
}
</style>